// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__37hEc","leftItems":"Footer_leftItems__1VXwc","rightItems":"Footer_rightItems__18qoS","links":"Footer_links__3Cx6x","title":"Footer_title__2-0u5"};